import DOMPurify, { type Config } from 'dompurify';

// Force rel="noopener noreferrer" on any anchor that opens a new tab so the opened
// page can't reach back through window.opener (reverse tabnabbing). DOMPurify hooks
// are global, so this hardens every purify* helper below. Guard the call: tests that
// partially mock 'dompurify' may omit addHook, and this runs at import time.
if (typeof DOMPurify.addHook === 'function') {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node instanceof Element && node.tagName === 'A' && node.hasAttribute('target')) {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

export const PURIFY_HTML_CONFIG: Config = {
  ALLOWED_TAGS: ['br', 'strong', 'em', 'b', 'i', 'a', 'span', 'ul', 'ol', 'li'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

export function purifyHtml(html: string): string {
  return DOMPurify.sanitize(html, PURIFY_HTML_CONFIG);
}

// For server-provided rich HTML (e.g. Document360 product-update notifications):
// DOMPurify's default allow-list, minus inline styling — the dashboard supplies
// its own styles for that content.
export const PURIFY_SERVER_HTML_CONFIG: Config = {
  FORBID_TAGS: ['style'],
  FORBID_ATTR: ['style'],
};

export function purifyServerHtml(html: string): string {
  return DOMPurify.sanitize(html, PURIFY_SERVER_HTML_CONFIG);
}
